export enum STORY_GROUPS {
  ACCEPTED = 'accepted',
  CURRENT = 'current',
  SCHEDULED = 'scheduled',
  UNSCHEDULED = 'unscheduled',
}
